var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group mt-2" }, [
    _c("label", { staticClass: "form-label" }, [
      _vm._v("\n        " + _vm._s(_vm.__t(this.title)) + "\n    "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "input-group flex-nowrap" },
      [
        _c("b-form-radio-group", {
          attrs: {
            id: "btn-radios-" + _vm.title.toLowerCase(),
            "button-variant": "outline-primary",
            options: _vm.draw_radio_options,
            name: _vm.title.toLowerCase(),
            buttons: "",
          },
          on: { change: _vm.updateValue },
          model: {
            value: _vm.localValue,
            callback: function ($$v) {
              _vm.localValue = $$v
            },
            expression: "localValue",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }